<template>
  <div class="view-contanier">
    <div class="opt">
      <div class="btn" @click="add">
        <svg-icon v-permissson="'add'" className="icon" iconClass="add" />新增
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :loading="loading"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="isActived" slot-scope="row">
          <div
            class="circle"
            :style="{
              'background-color': row.scope.isActived ? ' #35BA83' : '#FE453D',
            }"
          ></div>
          {{ row.scope.isActived ? "使用中" : "未使用" }}
        </template>
        <template slot="userRole" slot-scope="row">
          <div v-for="(item, $index) in row.scope.userRole" :key="$index">
            <el-tag>{{ item.key }}</el-tag>
          </div>
        </template>
        <template slot="opt" slot-scope="row">

          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-permissson="'enable_disable'"
                  class="opt-item"
                  @click=" () => {
                    changeStatus(!row.scope.isActived, row.scope);
                  }"
                >{{ !row.scope.isActived ? "启用" : "停用" }}</el-button
                >
                <el-button
                  v-permissson="'distribute'"
                  class="opt-item"
                  @click="userRole(row.scope)"
                >权限分配</el-button
                >
              </div>
            </div>
            <img
              slot="reference"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
      </BaseTable>
    </div>
    <UserRoleDialog
      :dialogFormVisible="dialogFormVisible"
      :userRoleId="editData.id"
      @ok="ok"
      @cancel="cancel"
    ></UserRoleDialog>
    <add-user-role
      :dialogVisible="dialogVisible"
      @ok="ok2"
      @cancel="cancel2"></add-user-role>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import {
  getUserRolePages,
  disableUserRole,
  enableUserRole
} from '@/api/setting'
import UserRoleDialog from './components/UserRoleDialog.vue'
import AddUserRole from './components/AddUserRole.vue'
import { myMixins } from '@/mixins'
export default {
  name: 'UserRole',
  components: { BaseTable, UserRoleDialog, AddUserRole },
  mixins: [myMixins],
  data() {
    return {
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      loading: false,
      tableData: {
        fileds: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'userRoleNameCH',
            label: '中文名',
            width: '180px',
            fixed: 'left'
          },
          {
            filed: 'userRoleNameEN',
            label: '英文名',
            width: '180px'
          },
          {
            filed: 'isActived',
            label: '状态',
            width: '180px',
            isCustom: true
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '180px',
            formatter: (row) =>
              row.createdOn ? row.createdOn.slice(0, row.createdOn.length - 3) : ''
          },
          {
            filed: 'createdName',
            label: '创建人',
            width: '180px',
            isSort: true
          },
          {
            filed: 'updatedOn',
            label: '更新时间',
            width: '180px',
            formatter: (row) =>
              row.updatedOn ? row.updatedOn.slice(0, row.updatedOn.length - 3) : ''
          },
          {
            filed: 'updatedName',
            label: '更新人',
            width: '180px'
          },
          {
            filed: 'isActived',
            label: '客户跟进组别',
            width: '180px',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      height: 0,
      dialogFormVisible: false,
      dialogVisible: false,
      editData: {},
      sortable: {}
    }
  },
  computed: {},
  created() {
    this.getList(this.pagerConfig)
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable
          }
        }
        getUserRolePages(params).then((res) => {
          console.log(res)
          if (res.success) {
            this.loading = false
            this.tableData.total = res.data.total
            this.tableData.columns = res.data.list
          } else {
            this.loading = false
            this.$message.error(res.errorMessage)
          }
        })
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    handlePageChange(pager) {
      this.pagerConfig = {
        ...this.pagerConfig,
        ...pager
      }
      const params = {
        ...this.pagerConfig,
        ...pager
      }
      this.getList(params)
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getList(this.pagerConfig)
    },
    userRole(row) {
      this.editData = row
      this.dialogFormVisible = true
    },
    add() {
      this.dialogVisible = true
    },
    ok() {
      this.dialogFormVisible = false
    },
    cancel() {
      this.dialogFormVisible = false
    },
    ok2() {
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.dialogVisible = false
    },
    cancel2() {
      this.dialogVisible = false
    },
    changeStatus(value, row) {
      console.log(value, row)
      const obj = {
        userRoleId: row.id
      }
      if (value) {
        enableUserRole(obj).then((res) => {
          if (res.success) {
            this.$message.success('启用成功')
          } else {
            this.$message.error(res.errorMessage)
          }
          this.getList(this.pagerConfig)
        })
      } else {
        disableUserRole(obj).then((res) => {
          if (res.success) {
            this.$message.success('停用成功')
          } else {
            this.$message.error(res.errorMessage)
          }
          this.getList(this.pagerConfig)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .opt {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .btn {
    width: 80px;
    height: 30px;
    background:  rgb(18,88,188);
    border-radius: 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  }
  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }
  .table-opt:deep(.el-button) {
    padding: 0;
  }
  .status {
    width: 28px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    line-height: 20px;
    margin-left: 5px;
    margin-right: 31px;
  }
}
</style>
